// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__itrUX","icon":"style_icon__f_8L_"};